import { memo } from 'react';
import { CanvasTransformLayer } from './CanvasTransformLayer';
import { CanvasEdgePipeline } from './CanvasEdgePipeline';
import { CanvasEntityLayer } from './CanvasEntityLayer';
import { BoxSelectOverlay } from './BoxSelectOverlay';
import { AlignmentGuidesOverlay } from './AlignmentGuidesOverlay';

function CanvasCanvasInner({ resourceDropTargetId }: { resourceDropTargetId?: string | null }) {
  return (
    <CanvasTransformLayer>
      <CanvasEdgePipeline />
      <CanvasEntityLayer resourceDropTargetId={resourceDropTargetId ?? null} />
      <BoxSelectOverlay />
      <AlignmentGuidesOverlay />
    </CanvasTransformLayer>
  );
}

export const CanvasCanvas = memo(CanvasCanvasInner);
